import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'border-spinner',
  templateUrl: './border-spinner.component.html',
  styleUrls: ['./border-spinner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BorderSpinnerComponent {
  @Input() centered: boolean;
  @Input() loaderClass: string = '';
}
